import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Popover, PopoverBody } from 'reactstrap';

const HotSpotPopover = ({
  closeHotSpotPopover,
  hotSpot,
  playHotSpotAnimation,
  showHotSpotPopover,
  toggleTipPopover,
}) => {
  const [hotSpotText, setHotSpotText] = useState('');

  useEffect(() => {
    getHotSpotText();
  });

  const getHotSpotText = () => {
    switch (hotSpot) {
      case 'bswLandscape':
      case 'bswPortrait':
        setHotSpotText('SEE SOMETHING ZOOMY?');
        break;
      case 'clinicLandscape':
      case 'clinicPortrait':
        setHotSpotText('SEE SOMETHING FUN?');
        break;
      case 'helicopterLandscape':
      case 'helicopterPortrait':
        setHotSpotText('SEE SOMETHING FLOATY?');
        break;
      case 'pharmacyLandscape':
      case 'pharmacyPortrait':
        setHotSpotText('SEE SOMETHING NOSTALGIC?');
        break;
      case 'sunLandscape':
      case 'sunPortrait':
        setHotSpotText('SEE SOMETHING SPORTY?');
        break;
      default:
        setHotSpotText('SEE SOMETHING FUN?');
    }
  };

  return (
    <Popover
      className='hotspot-popover'
      container='waiting-room-container'
      fade={false}
      placement='bottom'
      hideArrow={true}
      isOpen={showHotSpotPopover}
      target={hotSpot}
    >
      <PopoverBody>
        <Button
          className='hotspot-button'
          color='primary'
          onClick={toggleTipPopover}
        >
          SEE A BSWH TIP?
        </Button>
        <p className='or-text'>or</p>
        <Button
          className='hotspot-button'
          color='primary'
          onClick={playHotSpotAnimation}
        >
          {hotSpotText}
        </Button>
        <div className='close-popover' onClick={closeHotSpotPopover}>
          Close
        </div>
      </PopoverBody>
    </Popover>
  );
};

HotSpotPopover.defaultProps = {
  closeHotSpotPopover: () => {},
  hotSpot: '',
  playHotSpotAnimation: () => {},
  showHotSpotPopover: false,
  toggleTipModal: () => {},
};

HotSpotPopover.propTypes = {
  closeHotSpotPopover: PropTypes.func,
  hotSpot: PropTypes.string,
  playHotSpotAnimation: PropTypes.func,
  showHotSpotPopover: PropTypes.bool,
  toggleTipPopover: PropTypes.func,
};

export default HotSpotPopover;
